import {
	DECADE_GRID_LEADING_YEARS,
	DECADE_GRID_YEARS,
} from "web_myplann/Shared/Components/FlatRow/datePanelHelpers";
import { getDecadeStart } from "web_myplann/Shared/Components/FlatRow/getDecadeStart";

export const getDecadeGridYears = (year: number): number[] => {
	const firstYear = getDecadeStart(year) - DECADE_GRID_LEADING_YEARS;

	return Array.from(
		{ length: DECADE_GRID_YEARS },
		(_, index) => firstYear + index,
	);
};
